module.exports = __webpack_public_path__ + "3a091b8b0af2225155c70e0915e1a0c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/onedrive.png
// module id = 3139
// module chunks = 1